module.exports = __webpack_public_path__ + "static/peixun-fda227c6be469504cd5fac1eddab25d7.png";